<template>
  <div class="search-form-tags has-flyout element flex-1">
    <div class="tag-search" :class="{loading: loading}">
      <div class="form-group placeholder-field md">
        <input id="search-explore-tags" type="text" name="tags" data-tag-search :placeholder="placeholder"
               v-model="input" @focus="searchFocused = true" @blur="searchFocused = false" @keypress="handleKeypress"/>
      </div>

      <svg-icon id="loading" class="spin"></svg-icon>
    </div>

    <div class="flyout-menu region-results pos-left" :class="{hidden: results.length === 0}">
      <vue-simplebar class="inner">
        <ul class="listing location-options">
          <li v-for="result in results" @click="selectResult(result)">
            <svg-icon :id="resultIcon(result)"></svg-icon>
            {{ result.label }}
          </li>
        </ul>
      </vue-simplebar>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  props: {
    keepKeywordSelection: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },

  data () {
    return {
      loading: false,
      input: '',
      results: [],
      searchFocused: false,
    }
  },

  computed: {
    hasSearchTerm () {
      return this.input.length > 0
    },
  },

  watch: {
    input () {
      this.searchKeywords()
      this.$emit('input', this.input)
    },
  },

  created () {
    this.searchKeywords = debounce(() => {
      this.fetchKeywords()
    }, 250)
  },

  mounted () {
    window.addEventListener('click', this.delegatedHideDropdown)
    this.$on('clear', () => this.input = '')
  },

  beforeDestroy () {
    window.removeEventListener('click', this.delegatedHideDropdown)
  },

  methods: {
    delegatedHideDropdown (e) {
      if (!e.target.closest('.region-results')) {
        this.results = []
      }
    },

    fetchKeywords () {
      if (this.input.length < 3) {
        return
      }

      this.loading = true

      axios.get('/api/locations', { params: { query: this.input } })
          .then((response) => {
            if (this.loading) {
              this.results = [{ type: 'keyword', id: null, value: this.input, label: `${this.input}` }]
              this.results = this.results.concat(response.data || [])
            }
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
    },

    resultIcon (result) {
      switch (result.type) {
        case 'lga':
          return 'tentMoon'
        case 'region':
          return 'toggleMap'
        case 'keyword':
          return 'search'
      }

      return 'mapPin'
    },

    selectResult (result) {
      this.$emit('selected', result)

      if (result.type !== 'keyword' || !this.keepKeywordSelection) {
        this.input = ''
      }

      this.results = []
    },

    handleKeypress (e) {
      switch (e.key.toLowerCase()) {
        case 'enter':
          if (this.input.length >= 3) {
            this.loading = false
            this.selectResult({ type: 'keyword', id: null, value: this.input, label: `${this.input}` })
            e.preventDefault()
          }
          break
      }
    },
  },
}
</script>
